export const USER_AUTHORITIES = {
  CLIENT_BANK_SIGN: "ClientBankSign",
  CLIENT_BANK_NO_SIGN: "ClientBankNoSign",
  CLIENT_BANK_ONLY_VIEW: "ClientBankOnlyView",
} as const;

export const BANK_FOR_BANK_CLIENT_GROUP = "Б";

export const BANK_FOR_BANKS_USER_AUTHORITIES = [
  USER_AUTHORITIES.CLIENT_BANK_SIGN,
  USER_AUTHORITIES.CLIENT_BANK_NO_SIGN,
  USER_AUTHORITIES.CLIENT_BANK_ONLY_VIEW,
];

export const BANK_FOR_BANKS_USER_INN_CHAR = "0";
